import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MotionConfig } from 'motion/react'
import { GraphQLClientProvider } from '@utils/GraphQLClientProvider'
import Toaster from '@components/atoms/Toaster'

const queryClient = new QueryClient()

// Root wrapper rendered outside Inertia's context (around renderApp), so its
// providers also cover the modal stack, which renders outside any page layout.
function AppProviders({ children }) {
  return (
    <MotionConfig reducedMotion="user">
      <GraphQLClientProvider>
        <QueryClientProvider client={queryClient}>
          <main id="v2-root" className="tailwind tw:bg-white tw:font-sans">
            {children}
            <Toaster />
          </main>
        </QueryClientProvider>
      </GraphQLClientProvider>
    </MotionConfig>
  )
}

export default AppProviders
